import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useMemo } from 'react';
import { useDragControls } from 'framer-motion';
import 'swiper/css/pagination';
import 'swiper/css';
import { ObserveControlProvider } from 'console/shared/contexts/observe-control';
import { SwipableModal } from '../swipable';
import { createPortal } from 'react-dom';
import { CardsSlider } from '../../features/cards-slider';
function SwiperWithModalImpl(props) {
    const { onClose, opened, items, component, ...rest } = props;
    const drag_controls = useDragControls();
    const drag_handler = useMemo(() => ({
        onPointerDown: (event) => drag_controls.start(event),
    }), [drag_controls]);
    const slides = useMemo(() => items.map((item_details) => component(item_details, drag_handler, onClose)), [items, component, drag_handler]);
    return createPortal(_jsx(ObserveControlProvider, { drag_controls: drag_controls, onClose: onClose, children: _jsx(SwipableModal, { opened: opened, children: _jsx(CardsSlider, { ...rest, children: slides }) }) }), document.body);
}
export const SwiperWithModal = memo(SwiperWithModalImpl);
